import React, { useState } from "react";

import { ModalBackground } from "../../dashboard/hometab/styles";
import { subscribeSchema } from "../../../validations/subscribe";
import { yupResolver } from "@hookform/resolvers/yup";
import { API_URL } from "../../../constants";
import axios from "axios";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ModalCard, CardHeader, Input, Button } from "./styles";

type FormData = yup.InferType<typeof subscribeSchema>;

export default function SubscribeModal({ setIsSub, businessUuid }: any) {
  const [isloading, setisloading] = useState(false);

  const { register, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(subscribeSchema),
  });
  const { errors } = formState;

  const createSubcribeRequest = async (data: any) => {
    setisloading(true);
    const formData = {
      email: data.email,
      businessUuid: businessUuid,
    };

    axios
      .post(`${API_URL}/profile/subscribe`, formData)
      .then((response) => {
        setisloading(false);
        toast.success("Subscribed successfully");
        setIsSub(false);
        reset();
      })
      .catch((error) => {
        setisloading(false);
        toast.error("Something went wrong");
      });
  };

  const submitValue: any = isloading ? (
    <div className="flex justify-center  text-[#ffffff] ...">
      <svg className="animate-spin  h-5 w-5  ..." viewBox="0 0 20 20" version="1.1" fill="#000000">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>ic_fluent_spinner_ios_20_regular</title> <desc>Created with Sketch.</desc>{" "}
          <g id="🔍-System-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            {" "}
            <g id="ic_fluent_spinner_ios_20_regular" fill="#ffffff" fillRule="nonzero">
              {" "}
              <path
                d="M10,3 C6.13401,3 3,6.13401 3,10 C3,10.2761 2.77614,10.5 2.5,10.5 C2.22386,10.5 2,10.2761 2,10 C2,5.58172 5.58172,2 10,2 C14.4183,2 18,5.58172 18,10 C18,14.4183 14.4183,18 10,18 C9.72386,18 9.5,17.7761 9.5,17.5 C9.5,17.2239 9.72386,17 10,17 C13.866,17 17,13.866 17,10 C17,6.13401 13.866,3 10,3 Z"
                id="🎨-Color"
              >
                {" "}
              </path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
      <span className="ml-2">Processing...</span>
    </div>
  ) : (
    "Subscribe"
  );

  return (
    <ModalBackground
      onClick={() => {
        setIsSub(false);
      }}
    >
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <form onSubmit={handleSubmit(createSubcribeRequest)} className="w-[100%]">
          <CardHeader>
            <h2>Subscribe</h2>
          </CardHeader>
          <Input type="text" placeholder="Your email Address" {...register("email")} />
          {errors?.email && <p className="text-xs mb-2 text-red-600">{errors.email?.message}</p>}
          <Button>{submitValue}</Button>
        </form>
      </ModalCard>
    </ModalBackground>
  );
}
